import { Exclude } from 'class-transformer';
import {
  ArrayNotEmpty,
  IsBoolean,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { BaseCreateDto, BaseUpdateDto } from '../base.dto';
import { ConditionTypeDto } from '../condition-type.dtos';
import { NamedEntityDto } from './named.dto';

export interface GeneralSymptomDto extends NamedEntityDto {
  requiresUserInput?: boolean;
  conditionTypes?: ConditionTypeDto[];
  /** @deprecated Use conditionTypes. Kept for pre-rename clients that still read this field. */
  skinTypeConditions?: ConditionTypeDto[];
}

export class CreateGeneralSymptomDto
  extends BaseCreateDto
  implements Partial<GeneralSymptomDto>
{
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsBoolean()
  requiresUserInput: boolean;

  @IsUUID('all', { each: true })
  @ArrayNotEmpty()
  conditionTypeIds: string[];

  @Exclude()
  conditionTypes?: never;
}

export class UpdateGeneralSymptomDto
  extends BaseUpdateDto
  implements Partial<GeneralSymptomDto>
{
  @IsOptional()
  @IsNotEmpty()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsOptional()
  @IsBoolean()
  requiresUserInput?: boolean;

  @IsOptional()
  @IsUUID('all', { each: true })
  @ArrayNotEmpty()
  conditionTypeIds?: string[];

  @Exclude()
  conditionTypes?: never;
}
